import Loading from '../../../Common/Loading';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';
import { TenagerMothers } from './TenagerMothers';
import { MotherRace } from './MotherRace';
import { MotherMaritalStatus } from './MotherMaritalStatus';
import { MotherScholarity } from './MotherScholarity';
import { MotherSeries } from './MotherSeries';
import { MotherAge } from './MotherAge';
import { FatherAge } from './FatherAge';

export const Charts = () => {
    const { isLoading } = useParentsInfoChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-row-dashboards">
                <TenagerMothers />
            </div>
            <div className="charts-side-by-side-dashboards">
                <MotherRace />
                <MotherMaritalStatus />
            </div>
            <div className="charts-side-by-side-dashboards">
                <MotherScholarity />
                <MotherSeries />
            </div>
            <div className="charts-side-by-side-dashboards">
                <MotherAge />
                <FatherAge />
            </div>
        </>
    );
};
